// extracted by mini-css-extract-plugin
module.exports = {"comp":"JN_comp__SCloc"};